import React from 'react'
import styled from 'styled-components'
import Text from 'core-system/Text'
import Loading from 'core-system/Loading'
import Divider from 'core-system/Divider'
import palette from 'core-system/Themes/palette'
import NoDataText from 'employee-platform/shared/components/NoDataText'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/config/store'
import SubscriptionDetails from './SubscriptionDetails'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1rem;
`

const HelperText = styled(Text)`
  line-height: 1.35;
`

const HelperTextContainer = styled.div`
  padding: 0.625rem 0.75rem;
  border-radius: 0.625rem;
  background-color: ${(props) => props.theme.palette.primary.pink50};
`

const SupportLink = styled.a`
  color: ${(props) => props.theme.palette.primary.pink800};
  font-weight: 600;
`

const SUPPORT_EMAIL = 'support@movewithfleet.com'

const AutoTopupSubscriptionDetails = React.memo(() => {
  const { subscriptions, subscriptionLoading } = useSelector(
    (state: AppState) => state.autoTopup
  )

  if (subscriptionLoading && subscriptions.length === 0) {
    return (
      <Container>
        <Text variant='action1'>Your Recurring Payments</Text>
        <Loading isCard={false} />
      </Container>
    )
  }

  return (
    <Container>
      <Text variant='action1'>Your Recurring Payments</Text>
      {subscriptions.length > 0 ? (
        <>
          {subscriptions.map((subscription, index) => (
            <React.Fragment key={subscription.subscriptionId}>
              {index > 0 ? (
                <Divider direction='horizontal' margin='0.25rem 0' />
              ) : null}
              <SubscriptionDetails subscription={subscription} />
            </React.Fragment>
          ))}
          <HelperTextContainer>
            <HelperText variant='body2' textColor={palette.grey.grey600}>
              To change or remove this recurring payment, reach out to Fleet
              support at{' '}
              <SupportLink href={`mailto:${SUPPORT_EMAIL}`}>
                {SUPPORT_EMAIL}
              </SupportLink>
              .
            </HelperText>
          </HelperTextContainer>
        </>
      ) : (
        <NoDataText text='NO ACTIVE SUBSCRIPTION' center={false} />
      )}
    </Container>
  )
})

if (process.env.NODE_ENV !== 'production') {
  AutoTopupSubscriptionDetails.displayName = 'AutoTopupSubscriptionDetails'
}

export default AutoTopupSubscriptionDetails
